import { Button, Grid } from "@aws-amplify/ui-react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import LocalizedStrings from "react-localization";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

import ItemListCollection from "../ItemListCollection";
import { listPermissions } from "graphql/queries";

export const PermissionsChoose = ({
  initPermissionsGranted = [],
  onChangePermissionsGranted,
  resetValues,
}) => {
  const [permissionsAvailable, setPermissionsAvailable] = useState([]);
  const [permissionsGranted, setPermissionsGranted] = useState([]);
  const [permissionsAvailableSelected, setPermissionsAvailableSelected] =
    useState([]);
  const [permissionsGrantedSelected, setPermissionsGrantedSelected] = useState(
    []
  );
  const [keywordPermissionsGranted, setKeywordPermissionsGranted] =
    useState("");

  async function fetchPermissionsAvailable(keyword, diffPermissions) {
    try {
      const permissionsData = await API.graphql(
        graphqlOperation(listPermissions, {
          limit: 500,
          filter: keyword
            ? {
                or: [
                  {
                    name: { contains: keyword },
                  },
                  {
                    description: { contains: keyword },
                  },
                ],
              }
            : {},
        })
      );
      const permissionsItems = permissionsData.data.listPermissions.items;
      setPermissionsAvailable(
        permissionsItems
          ?.filter(
            (permissionItem) =>
              !diffPermissions?.some(
                (diffUs) => diffUs.id === permissionItem.id
              )
          )
          ?.map((permissionItem) => ({
            id: permissionItem.id,
            name: permissionItem.description || permissionItem.name,
          }))
      );
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    setPermissionsGranted(initPermissionsGranted);
    fetchPermissionsAvailable(undefined, initPermissionsGranted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initPermissionsGranted, resetValues]);

  useEffect(() => {
    if (onChangePermissionsGranted)
      onChangePermissionsGranted(permissionsGranted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsGranted]);

  const cleanSelected = () => {
    setPermissionsAvailableSelected([]);
    setPermissionsGrantedSelected([]);
  };

  const setInAvailable = (items) => {
    setPermissionsAvailable((prevSt) => [...prevSt, ...items]);
    setPermissionsGranted((prevSt) =>
      prevSt.filter(
        (prev) => !items?.some((permission) => permission.id === prev.id)
      )
    );
    cleanSelected();
  };

  const setInGranted = (items) => {
    setPermissionsGranted((prevSt) => [...prevSt, ...items]);
    setPermissionsAvailable((prevSt) =>
      prevSt.filter(
        (prev) => !items?.some((permission) => permission.id === prev.id)
      )
    );
    cleanSelected();
  };

  const onSearchPermissionsGranted = (keyword) => {
    setKeywordPermissionsGranted(keyword);
  };

  return (
    <Grid templateColumns={{ base: "1fr", large: "2fr 1fr 2fr" }} gap="30px">
      <div>
        <div className="fs-5 mb-3">{strings.permissions.available}</div>
        <ItemListCollection
          items={permissionsAvailable}
          selectedItems={permissionsAvailableSelected}
          setSelectedItems={setPermissionsAvailableSelected}
          onSearchSubmit={(keyword) =>
            fetchPermissionsAvailable(keyword, permissionsGranted)
          }
          orderBy="ASC"
        />
      </div>
      <div style={styles.containerButtons}>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(permissionsGrantedSelected)}
        >
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(permissionsGranted)}
        >
          <IoIosArrowBack />
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(permissionsAvailableSelected)}
        >
          <IoIosArrowForward />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(permissionsAvailable)}
        >
          <IoIosArrowForward />
          <IoIosArrowForward />
        </Button>
      </div>
      <div>
        <div className="fs-5 mb-3">{strings.permissions.granted}</div>
        <ItemListCollection
          items={
            keywordPermissionsGranted
              ? permissionsGranted.filter((permissionGr) =>
                  permissionGr.name
                    .toLowerCase()
                    .includes(keywordPermissionsGranted?.toLowerCase())
                )
              : permissionsGranted
          }
          selectedItems={permissionsGrantedSelected}
          setSelectedItems={setPermissionsGrantedSelected}
          onSearchSubmit={onSearchPermissionsGranted}
          orderBy="ASC"
        />
      </div>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    permissions: {
      available: "Permisos disponibles",
      granted: "Permisos otorgados",
    },
    responses: {
      errorFetch: "Error al consultar permisos",
    },
  },
});

const styles = {
  containerButtons: {
    display: "flex",
    justifyContent: "center",
    flexFlow: "column",
    gap: "10px",
  },
  buttonActions: {
    width: "65px",
    alignSelf: "center",
  },
};

export default PermissionsChoose;
